import { render, staticRenderFns } from "./text-dropdown.vue?vue&type=template&id=e07df66e&scoped=true"
import script from "./text-dropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./text-dropdown.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./text-dropdown.vue?vue&type=style&index=0&id=e07df66e&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e07df66e",
  null
  
)

export default component.exports